import React from 'react';

import PropTypes from 'prop-types';

const Form = ({ children, className, ...formProps }) => {
    return (
        <form className={className} {...formProps}>
            { children }
        </form>
    );
};

Form.propTypes = {
    children: PropTypes.node,
    className: PropTypes.string,
};

export default Form;
